import React from "react";
import { InputAdornment, TextField } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";

const CustomSearchBar = ({
  rows,
  setFilteredRows,
  setIsSearch,
  searchVal,
  setSearchVal,
  setpagination,
}) => {
  const handleChange = async (e) => {
    // Reset page to first page when search is performed
    setIsSearch(e.target.value.length);
    setSearchVal(e.target.value);
    setpagination && setpagination(e.target.value);

    await setFilteredRows(
      e.target.value.length > 0
        ? rows.filter((row) =>
            Object.values(row).some(
              (value) =>
                typeof value === "string" &&
                value.toLowerCase().includes(e.target.value.toLowerCase())
            )
          )
        : rows
    );
  };

  return (
    <TextField
      fullWidth
      variant="outlined"
      value={searchVal}
      placeholder="Search..."
      onChange={handleChange}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon />
          </InputAdornment>
        ),
      }}
    />
  );
};

export default CustomSearchBar;
